'use client';

import { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

interface LikeButtonProps {
  articleId: string;
  initialLikes?: number;
  className?: string;
}

export function LikeButton({ articleId, initialLikes = 0, className }: LikeButtonProps) {
  const [likes, setLikes] = useState(initialLikes);
  const [isLiked, setIsLiked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Check if user has already liked this article
    if (typeof window !== 'undefined') {
      const likedArticles = JSON.parse(localStorage.getItem('likedArticles') || '[]');
      setIsLiked(likedArticles.includes(articleId));
    }
  }, [articleId]);

  const handleLike = async () => {
    if (isLoading) return;

    setIsLoading(true);

    try {
      const likedArticles = JSON.parse(localStorage.getItem('likedArticles') || '[]');

      if (isLiked) {
        // Unlike
        setLikes((prev) => Math.max(0, prev - 1));
        setIsLiked(false);
        const newLiked = likedArticles.filter((id: string) => id !== articleId);
        localStorage.setItem('likedArticles', JSON.stringify(newLiked));
      } else {
        // Like
        setLikes((prev) => prev + 1);
        setIsLiked(true);
        likedArticles.push(articleId);
        localStorage.setItem('likedArticles', JSON.stringify(likedArticles));
      }

      // 在生产环境中，同步到数据库
      // const supabase = createClient();
      // await supabase.from('articles').update({ likes }).eq('id', articleId);
    } catch (error) {
      console.error('Like error:', error);
      toast.error('操作失败，请稍后重试');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleLike}
      disabled={isLoading}
      className={`gap-2 ${isLiked ? 'text-red-500' : 'text-muted-foreground'} ${className || ''}`}
    >
      {isLiked ? (
        <Heart className="h-5 w-5 fill-current" />
      ) : (
        <Heart className="h-5 w-5" />
      )}
      <span>{likes}</span>
    </Button>
  );
}
